import React from 'react';
import { Button } from '@/components/ui/button';
import { KeenIcon } from '@/components/keenicons';
import { FormattedMessage, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCircleRight } from '@fortawesome/free-solid-svg-icons';
import { useGetAgent } from '@/hooks/useAgent';
import { useAuth } from '@/hooks/useAuth';


const AgentWelcomeBox = ({ onCreate }) => {
  const intl = useIntl();
  const {userData} = useAuth()
  const { data: agent, isLoading } = useGetAgent(userData?.uID);

  // Fallback values nếu agent data null
  const botIcon = agent?.data?.bot_icon || "/media/images/logo_mini_chatme.png";
  const agentName = agent?.data?.name || "ChatMe.Vn";
  const introduction = agent?.data?.introduction || intl.formatMessage({ id: 'AGENTS.HOME.INTRO_DEFAULT', defaultMessage: '👋 Hello! I\'m Chatme!' });

  return (
    <>
      {isLoading ? (
        <div className="flex justify-center items-center py-10">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
        </div>
      ) : agent?.data ? (
        /* user đã có agent */
        <div className="overflow-hidden">
          <p className='text-xl pb-4'>
            <FormattedMessage id="AGENTS.HOME.ALREADY_CREATED" defaultMessage="You already created an agent" />
          </p>
          <table className="w-screen max-w-4xl border border-gray-200 rounded-lg shadow-sm">
            <thead>
              <tr className="bg-white border-b border-gray-200">
                <th className="px-4 py-3 text-center text-sm font-medium text-gray-700">
                  <FormattedMessage id="AGENTS.HOME.TABLE.BOT_ICON" defaultMessage="Bot icon" />
                </th>
                <th className="px-4 py-3 text-center text-sm font-medium text-gray-700">
                  <FormattedMessage id="AGENTS.HOME.TABLE.AGENT_NAME" defaultMessage="Agent name" />
                </th>
                <th className="px-4 py-3 text-center text-sm font-medium text-gray-700">
                  <FormattedMessage id="AGENTS.HOME.TABLE.INTRODUCTION" defaultMessage="Introduction" />
                </th>
                <th className="py-3 text-center text-sm font-medium text-gray-700"></th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-100 bg-gray-100 hover:bg-gray-200 cursor-pointer" onClick={onCreate}>
                <td className="px-4 py-3 flex justify-center">
                  <img src={botIcon} alt="" className='size-10'/>
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 text-center">{agentName}</td>
                <td className="px-4 py-3 text-sm text-gray-600 text-center">{introduction}</td>
                <td className="py-3 text-sm text-gray-600 text-center"><FontAwesomeIcon icon={faCircleRight} className='size-5 pr-3'/></td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        /* user chưa có agent */
        <div className="flex flex-col items-center gap-2">
          <div className="font-medium text-gray-800 text-center text-3xl">
            <FormattedMessage id="AGENTS.HOME.WELCOME1" />
            <br />
            <FormattedMessage id="AGENTS.HOME.WELCOME2" />
          </div>
          <Button className="mt-2 bg-[#50CD54] flex items-center justify-between hover:bg-[#318434]" onClick={onCreate}>
            <FormattedMessage id="AGENTS.HOME.CREATE_NEW" />
            <FontAwesomeIcon icon={faArrowRight} />
          </Button>
        </div>
      )}
    </>
  );
};

export { AgentWelcomeBox }; 